export const categoriesIcon: Record<string, string> = {
  'News & Current Events': '🗞️',
  Technology: '💻',
  'Science & Education': '🔬',
  'Business & Finance': '💼',
  'Health & Wellness': '🧘',
  Entertainment: '🎬',
  Lifestyle: '🌿',
  'Food & Drink': '🍽️',
  Travel: '✈️',
  'Art & Design': '🎨',
  'Personal Development': '📈',
  'Shopping & Deals': '🛍️',
  'Social Media & Influencers': '📱',
  Gaming: '🎮',
  'Career & Jobs': '🧑‍💼',
  Sports: '🏅',
  'History & Culture': '🏛️',
  'Politics & Society': '⚖️',
  'Spirituality & Religion': '🕊️',
  'DIY & How-To': '🛠️',
};

export const categoryColors: Record<string, string> = {
  'News & Current Events': '#F44336',
  Technology: '#2196F3',
  'Science & Education': '#673AB7',
  'Business & Finance': '#4CAF50',
  'Health & Wellness': '#009688',
  Entertainment: '#FF5722',
  Lifestyle: '#8BC34A',
  'Food & Drink': '#FFC107',
  Travel: '#00BCD4',
  'Art & Design': '#E91E63',
  'Personal Development': '#3F51B5',
  'Shopping & Deals': '#FF9800',
  'Social Media & Influencers': '#9C27B0',
  Gaming: '#3F51B5',
  'Career & Jobs': '#607D8B',
  Sports: '#FF5722',
  'History & Culture': '#795548',
  'Politics & Society': '#7E9E9E',
  'Spirituality & Religion': '#D0D039',
  'DIY & How-To': '#FF7043',
};

export const predefinedCategories = Object.keys(categoriesIcon); 